import OrderReducer from './Reducers/OrderReducer'
import PaymentReducer from './Reducers/PaymentReducer'
import authReducer from './Reducers/authReducer'
import bannerReducer from './Reducers/bannerReducer'
import categoryReducer from './Reducers/categoryReducer'
import chatReducer from './Reducers/chatReducer'
import colorReducer from './Reducers/colorReducer'
import dashboardReducer from './Reducers/dashboardReducer'
import productReducer from './Reducers/productReducer'
import reklamReducer from './Reducers/reklamReducer'
// import userReducer from './Reducers/userReducer'
import shopReducer from './Reducers/shopReducer'

const rootReducer = {
  auth: authReducer,
  category: categoryReducer,
  color: colorReducer,
  reklam: reklamReducer,
  product: productReducer,
  // user: userReducer,
  shop: shopReducer,
  chat: chatReducer,
  order: OrderReducer,
  payment: PaymentReducer,
  dashboard: dashboardReducer,
  banner: bannerReducer,
}
export default rootReducer
